module.exports = __webpack_public_path__ + "img/西玥.b48077a.png";